import React, { useEffect, useState } from "react";
import Select from "@atlaskit/select";
import { useSelector } from "react-redux";

const SelectAction = ({ onSelectCallback, defaultSelected }) => {
  const flow = useSelector((state) => state.integration.flow);
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");

  useEffect(() => {
    let opt = [];
    if (flow.actions) {
      opt = flow.actions.map((a) => {
        return { label: a.name, value: a.id };
      });
      setOptions(opt);
    }
    if (defaultSelected) {
      //console.log(defaultSelected, opt);
      const actionOpt = opt.find((o) => o.value === defaultSelected)
      setSelectedOption(actionOpt);
      onSelectCallback(actionOpt)
    } else {
      setSelectedOption("");
    }
  }, [flow]);

  const handleOnChange = (e) => {
    setSelectedOption(e);
    onSelectCallback(e);
  };

  return (
    <Select
      className="ihub-action-select"
      options={options}
      value={selectedOption}
      spacing="compact"
      isRequired={false}
      onChange={handleOnChange}
      name="actionPicker"
    />
  );
};
export default SelectAction;
